
import { FileSearch, MessageSquare } from "lucide-react";

interface EmptyStateProps {
  onStartChat?: () => void;
  onUploadDocument?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onStartChat, onUploadDocument }) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-6">
      <div className="max-w-md text-center space-y-6">
        <div className="mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
            <img
              src="/logo_justicai_laib.png" 
              alt="Justiçai"
              className="w-12 h-12"
            />
          </div>
        </div>
        <h1 className="text-2xl font-bold tracking-tight">
          Bem-vindo ao Justiçai
        </h1>
        <p className="text-muted-foreground">
          Sua inteligência artificial jurídica para análise de documentos, resumos e orientação jurídica.
        </p>
        <div className="grid gap-2 mt-6">
          <div 
            className="flex items-center p-3 rounded-lg border bg-card shadow-sm cursor-pointer hover:bg-accent/50 transition-colors" 
            onClick={onUploadDocument}
          >
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center mr-3">
              <FileSearch className="w-4 h-4 text-primary" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium">Envie documentos jurídicos</p>
              <p className="text-xs text-muted-foreground">
                Envie PDFs, imagens ou documentos de texto para análise
              </p>
            </div>
          </div>
          <div 
            className="flex items-center p-3 rounded-lg border bg-card shadow-sm cursor-pointer hover:bg-accent/50 transition-colors" 
            onClick={onStartChat}
          >
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center mr-3">
              <MessageSquare className="w-4 h-4 text-primary" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium">Faça perguntas jurídicas</p>
              <p className="text-xs text-muted-foreground">
                Obtenha insights e orientação sobre assuntos jurídicos
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
